<template>
  <div v-click-outside="onClickOutside" class="sonar-alert-modal__wrapper">
    <button
      class="dialog-modal__close sonar-dialog-modal__close"
      @click="updateSonarStatus({ showStartAssessmentModal: false })"
    >
      <XIcon class="dialog-modal__close--icon">clear</XIcon>
    </button>
    <div
      class="sonar-alert-modal__dialog"
      @close-dialog-modal="
        updateSonarStatus({ showStartAssessmentModal: false })
      "
    >
      <p class="sonar-alert-modal__dialog-title">
        We’re sorry, Sonar assessments aren’t available on mobile devices yet.
      </p>
      <p class="sonar-alert-modal__dialog-info">
        To access Sonar assessments, please switch to a laptop or desktop
        computer.
      </p>
      <div
        class="sonar-assessments__actions-wrapper quiz-modal__dialog-modal-cta"
      >
        <button
          class="btn btn--primary sonar-alert-modal__dialog-cta"
          @click="updateSonarStatus({ showStartAssessmentModal: false })"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { XIcon } from 'vue-feather-icons'

export default {
  name: 'SonarMobileAlert',
  components: {
    XIcon,
  },
  methods: {
    ...mapActions({
      updateSonarStatus: 'sonar/updateSonarStatus',
    }),
    onClickOutside() {
      this.updateSonarStatus({ showStartAssessmentModal: false })
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-alert-modal {
  &__wrapper {
    height: fit-content;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 300;
    display: flex;
    align-items: flex-end;
    border-radius: 20px 20px 0px 0px;
    background: var(--glass-mid-gray);
    background-color: var(--charcoal);
    padding: 30px;
  }
  &__dialog {
    position: relative;
    background: transparent;
    width: 100%;
    color: var(--white);
    border-radius: 20px 20px 0px 0px;
    z-index: 300;
    &-title {
      font-size: rem(20);
      line-height: rem(26);
      font-weight: 700;
      margin: 34px 0 30px;
    }
    &-info {
      font-size: rem(14);
      line-height: rem(20);
      margin-bottom: 30px;
    }
    &-cta {
      width: 100%;
      height: 36px;
    }
  }
}
</style>
